import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

export function useAlertsPageEnabled(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.alerts_page)
  );
}
